export const kz = {
  title: 'Импрессум (Заңды деректер)',
  subtitle: 'EU-Verordnung 2018/302 және Эстония сауда кодексіне (äriseadustik) сәйкес міндетті мәліметтер · Жай-күйі: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Қызмет көрсетуші',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Эстония (Estonia)\n\n- **Registrikood (сауда тізілімінің нөмірі):** 14744075\n- **ҚҚС нөмірі / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Тізілім:** Eesti äriregister (Эстония сауда тізілімі)\n- **Кәсіпорын нысаны:** Osaühing (OÜ) — Эстония құқығы бойынша жауапкершілігі шектеулі серіктестік\n- **Тіркелген және реттелетін орны:** Эстония Республикасы, Еуропалық Одақ',
    },
    {
      id: 'responsible',
      title: 'Мазмұнға жауапты тұлға',
      body:
        '**Andreas A. Gleim**\nБас директор / Эстония сауда кодексіне (äriseadustik) және § 18 MStV (Германия) сәйкес мазмұнға жауапты\n\nЭлектрондық пошта: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Байланыс',
      body:
        'Электрондық пошта: [logixa.one/kontakt](/kontakt)\nВеб-сайт: [https://logixa.one](https://logixa.one)\n\nПлатформаға, серіктестікке, баспасөзге және деректерді қорғауға қатысты сұрауларыңызды жоғарыдағы электрондық пошта мекенжайы немесе [байланыс нысаны](/kontakt) арқылы бізге жібере аласыз.',
    },
    {
      id: 'eu',
      title: 'ЕО дауларын реттеу',
      body:
        'Еуропалық Комиссия даулауларды онлайн реттеу (OS) платформасын ұсынады:\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nБіз тұтынушылар дауларын реттеу органы алдында дауларды реттеу рәсіміне қатысуға дайын емеспіз және міндетті де емеспіз.',
    },
    {
      id: 'liability',
      title: 'Мазмұн үшін жауапкершілік',
      body:
        'Қызмет көрсетуші ретінде біз § 7 Abs. 1 TMG (Германия) және Эстония InfoTS актісіне сәйкес осы беттердегі өз мазмұнымыз үшін жалпы заңдар бойынша жауаптымыз. Алайда §§ 8-ден 10-ға дейінгі TMG баптарына сәйкес біз қызмет көрсетуші ретінде берілген немесе сақталған бөгде ақпаратты бақылауға міндетті емеспіз.\n\nЖалпы заңдар бойынша ақпаратты жоюға немесе оны пайдалануды бұғаттауға қатысты міндеттемелер бұған байланыссыз күшінде қалады. Дегенмен, осыған қатысты жауапкершілік нақты құқық бұзушылық туралы білген сәттен бастап қана туындауы мүмкін.',
    },
    {
      id: 'liability-links',
      title: 'Сілтемелер үшін жауапкершілік',
      body:
        'Біздің ұсынысымызда мазмұнына ықпал ете алмайтын үшінші тараптардың сыртқы веб-сайттарына сілтемелер бар. Сондықтан біз бұл бөгде мазмұн үшін кепілдік бере алмаймыз. Сілтеме берілген беттердің мазмұны үшін әрқашан тиісті жеткізуші немесе беттерді басқарушы жауапты болады.',
    },
    {
      id: 'copyright',
      title: 'Авторлық құқық',
      body:
        'Сайт операторлары жасаған осы беттердегі мазмұн мен туындылар авторлық құқықпен қорғалады. Авторлық құқық шегінен тыс көбейту, өңдеу, тарату және кез келген түрде пайдалану тиісті автордың не жасаушының жазбаша келісімін талап етеді.\n\nОсы беттің жүктемелері мен көшірмелеріне тек жеке, коммерциялық емес мақсатта пайдалануға рұқсат етіледі.',
    },
  ],
};
